// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3eC1B","error":"Textarea_error__2SupP","readonly":"Textarea_readonly__2iVXA","disabled":"Textarea_disabled__2uH0H"};